module.exports = __webpack_public_path__ + "static/media/3D.690d5a47.png";